<template>
  <div class="about-page">
    <section class="about-hero">
      <h1>我们专注短剧分发增长</h1>
      <p class="desc">
        围绕短剧的分发场景，我们搭建从内容匹配、渠道投放到数据复盘的完整链路，
        帮助项目在不同流量入口中实现更稳定的触达、转化与留存。
      </p>
    </section>

    <div class="content-body">
      <section class="about-grid">
        <article class="card">
          <h3>分发策略</h3>
          <p>按用户圈层与观看场景制定分发策略，明确首发路径与流量承接节奏。</p>
        </article>
        <article class="card">
          <h3>渠道协同</h3>
          <p>联动小程序内推荐位、社媒内容矩阵和私域触点，提升全链路曝光效率。</p>
        </article>
        <article class="card">
          <h3>转化优化</h3>
          <p>通过素材测试、落地页优化和追更机制设计，持续提升点击与完播表现。</p>
        </article>
      </section>

      <section class="timeline">
        <h2>短剧分发的标准执行流程</h2>
        <div class="steps">
          <div class="step">
            <h4>01 / 内容匹配</h4>
            <p>结合题材特征与目标人群，匹配最合适的渠道入口与推荐场景。</p>
          </div>
          <div class="step">
            <h4>02 / 投放执行</h4>
            <p>按周期推进素材投放与话题运营，保持新品曝光和追更热度。</p>
          </div>
          <div class="step">
            <h4>03 / 数据复盘</h4>
            <p>追踪播放、点击、留存等关键表现，持续优化后续分发策略。</p>
          </div>
        </div>
      </section>

      <section class="metrics">
        <div class="metric">
          <p class="num">多渠道</p>
          <p class="txt">覆盖信息流、社媒与私域触达路径</p>
        </div>
        <div class="metric">
          <p class="num">高频上新</p>
          <p class="txt">围绕短剧节奏保持持续分发热度</p>
        </div>
        <div class="metric">
          <p class="num">全链复盘</p>
          <p class="txt">从投放到留存的闭环优化机制</p>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: "AboutView"
};
</script>

<style scoped>
.about-page {
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  padding: 20px 0;
  color: #eff5f8;
}

.about-hero {
  margin-bottom: 48px;
  text-align: center;
}


h1 {
  margin: 12px 0 16px;
  font-size: 32px;
  line-height: 1.3;
}

.desc {
  margin: 0 auto;
  max-width: 640px;
  color: #9ab0bc;
  line-height: 1.8;
  font-size: 15px;
}

.content-body {
  display: flex;
  flex-direction: column;
  gap: 48px;
}

h2 {
  margin: 0 0 24px;
  font-size: 22px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  padding-bottom: 12px;
}

.about-grid {
  display: grid;
  gap: 32px;
  grid-template-columns: repeat(3, 1fr);
}

.card h3 {
  margin: 0 0 8px;
  font-size: 18px;
  color: #ff6f2c;
}

.card p, .step p {
  margin: 0;
  line-height: 1.7;
  color: #9ab0bc;
  font-size: 14px;
}

.steps {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.step h4 {
  margin: 0 0 8px;
  font-size: 16px;
}

.metrics {
  display: grid;
  gap: 32px;
  grid-template-columns: repeat(3, 1fr);
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding-top: 32px;
}

.metric {
  text-align: center;
}

.num {
  margin: 0 0 8px;
  font-size: 20px;
  font-weight: 700;
  color: #ffb684;
}

.txt {
  margin: 0;
  color: #9ab0bc;
  line-height: 1.5;
  font-size: 14px;
}

@media (max-width: 768px) {
  .about-grid, .metrics {
    grid-template-columns: 1fr;
    gap: 24px;
  }
}
</style>
